







































































































































































































































































































































































































































































































import { Component, Model } from "vue-property-decorator";
import { VHeaders, PaginationModel, VAction } from "@/models/pagedlistmodel";
import { DateTimeHelper as _dateTime } from "@/helper/date-time.helper";
import { Base } from "@/components/common/base";
import { GetRequestApprovalResponse } from "@/Alynk.dtos";
import { IDialogOption } from "@/models/dialog";
import { vendorService, attachmentService, expenseService, paymentService } from "@/shared";
import { CheckTrackingInfo } from "./vendor.recurring";
import { mapGetters } from "vuex";

@Component({
  props: ["methodName", "progress"],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
    ...mapGetters({ userId: "getUserId" }),
  },
  components: {
    Grid: () => import("@/components/common/app.grid.vue"),
    ExpenseCustomerReports: () =>
      import("@/components/expense/customerreport.list.vue"),
    AppDialog: () => import("@/components/common/app.dialog.vue"),
    Calendar: () => import("@/components/common/app.calendar.vue"),
  },
})
export default class VendorRequestApprovalPage extends Base {
  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public storeId: number = 0;
  public vendorNumber: number = 0;
  public vendorRequestId: number = 0;

  public requestId: number = 0;
  public rejectionComment: string = "";
  public status: any = "Pending";
  public applyMinimumStartDate: boolean = false;
  public showApprovalDialog: boolean = false;
  public processedRequest: any[] = [];
  public expenseTaskActions: any[] = [];
  public pagedExpenseTaskRecords: any[] = [];
  // public loading: boolean = false;
  public decisionType: string = "";
  public overriderApprovalMsg: string = "";
  public showVendorRequest: boolean = true;
  public showMyTasks: boolean = true;
  public approvalStatus: string;
  public dialogSchedulePaymentConfirmation: boolean = false;
  public dialogReScheduleConfirmation: boolean = false;
  public dialogImmediateApproveConfirmation: boolean = false;
  public dialogImmediateRejectConfirmation: boolean = false;
  public disbaleSchedulePaymentRejectionTextArea: boolean = false;
  public disableReSchedulePaymentRejectionTextArea: boolean = false;
  public schedulePaymentBtnLoading: boolean = false;
  public reScheduleDialogBtnLoading: boolean = false;

  public reSchedulePaymentBtnLoading: boolean = false;
  public menuDate: boolean = false;
  public reScheduleDatePicker: boolean = false;
  public menuTime: boolean = false;

  public paymentBtnLoading: boolean = false;
  public reSchedulePaymentLoading: boolean = false;

  public isRequestPaymentScheduled: boolean = false;
  public isStatusPending: boolean = false;

  public isNeedsExtraApproval: boolean = false;
  public isRequiresMultipleApprovals: boolean = false;

  public paymentSendDate: string = _dateTime.currentDate(_dateTime.addDays(new Date(), 1));
  public paymentRescheduleDate: string = _dateTime.currentDate(_dateTime.addDays(new Date(), 1));
  public calendarMinDate: string = _dateTime.currentDate(_dateTime.addDays(new Date(), 1));

  // public paymentSendDate: string = _dateTime.currentDate();
  // public calendarMinDate: string = _dateTime.currentDate();

  public checkBookDetails: CheckTrackingInfo[] = [];
  public message: string = "";
  public vendorId: string = "";
  public userId: string;
  public filters: any[] = [
    { text: this.$parent.$t("vendorRequestApproval.all"), value: "All" },
    {
      text: this.$parent.$t("vendorRequestApproval.pending"),
      value: "Pending",
    },
    {
      text: this.$parent.$t("vendorRequestApproval.approved"),
      value: "Approved",
    },
    { text: "AutoApproved", value: "AutoApproved" },
    { text: "Scheduled", value: "Scheduled" },
    { text: "In-Progress", value: "InProgress" },
  ];
  public attachmentActions: any[] = [];
  public attachmentsList: any = [];
  public vendorLineItemsList: any = [];

  public flags: any = {
    searched: false,
  };
  public params: any = {
    startDate: "",
    endDate: "",
  };
  // public dialogAttachments: IDialogOption = {
  //     width: 610,
  //     title: this.$parent.$t('vendorRequestApproval.attachments') as string,
  //     model: false,
  //     contentClass: 'pa-0',

  // };
  public dialogAttachments: boolean = false;
  public userQuestion: string = "";
  public questionLoading: boolean = false;
  public isRedirectToConversation: boolean = false;
  public questionGridList: any = [];
  public questionGridLoading: boolean = false;
  public questionPagination = new PaginationModel("createdAt", true, 5);
  public attachmentHeaderText: string = "";
  public dialogQuestion: IDialogOption = {
    width: 610,
    title: "Ask a Question",
    model: false,
    loading: false,
    action: {
      color: "success",
      icon: "fa-paper-plane",
      text: "Send",
    },
    onAction: this.ondialogQuestionActionClick,
  };

  public dialogLineItems: IDialogOption = {
    width: 1300,
    title: "Expense Line Items",
    model: false,
  };

  public dialogviewApprovers: IDialogOption = {
    width: 800,
    title: "Approvers Detail",
    model: false,
  };

  public pagedVendors: GetRequestApprovalResponse[] = [];

  public vendorsActions: any[] = [];

  public vendorsLineItemActions: any[] = [];
  public loading: boolean = false;
  public customerloading: boolean = false;

  public pagination = new PaginationModel("id");

  public attachmentPagination = new PaginationModel("id");
  public attachmentloading: boolean = false;
  public lineItemsloading: boolean = false;
  public storeKey: number = 0;
  public isBtnDisableRequestApproval: boolean = false;
  public isBtnDisableRequestReject: boolean = false;
  public isBtnShowApproval: boolean = false;
  public isBtnShowReject: boolean = false;
  public isBtnShowQuestion: boolean = false;
  public isShowConversationGrid: boolean = false;
  public selectedExpenseId: number = 0;
  public selectedStoreId: number = 0;

  public submitUserId: string = "";
  public transactionHeaderId: string = "";
  public externalId: string = "";
  public ApproversList: any = [];
  public conversationId: string = "";
  public isQueryConversationId: boolean = false;
  public vendorConversationToNumber: string = "";
  public disableSchedulePaymentSection: boolean = false;
  public disableReSchedulePaymentSection: boolean = false;
  public schedulePaymentHintText: string = "";

  public hasApprovalPermissions: boolean = false;
  public isExtraApprovalRequired: boolean = false;
  public isRequestCompleted: boolean = false;
  public disableScheduleSection: boolean = false;


  public dialogConfirmation: IDialogOption = {
    width: 400,
    title: this.$parent.$t("vendorRequestApproval.titleConfirmation") as string,
    model: false,
    loading: false,
    action: {
      color: "success",
      icon: "fas fa-check",
      text: this.$parent.$t("vendorRequestApproval.agree") as string,
      disable: false,
    },
    onAction: (): void => {
      this.rejectionSubmit();
    },
  };

  public trackingDialog: IDialogOption = {
    width: 620,
    title: "Tracking Info",
    model: false,
    loading: false,
  };

  public approveDialogConfirmation: IDialogOption = {
    width: 400,
    title: this.$parent.$t("vendorRequestApproval.titleConfirmation") as string,
    model: false,
    loading: false,
    action: {
      color: "success",
      icon: "fas fa-check",
      text: this.$parent.$t("vendorRequestApproval.agree") as string,
      disable: false,
    },
    onAction: (): void => {
      this.approvalSubmit();
    },
  };

  public immediateApproveDialogConfirmation: IDialogOption = {
    width: 400,
    title: this.$parent.$t("vendorRequestApproval.titleConfirmation") as string,
    model: false,
    loading: false,
    action: {
      color: "success",
      icon: "fas fa-check",
      text: 'Approve',
      disable: false,
    },
    onAction: (): void => {
      this.immediateApprovalSubmit();
    },
  };

  public immediateRejectDialogConfirmation: IDialogOption = {
    width: 400,
    title: this.$parent.$t("vendorRequestApproval.titleConfirmation") as string,
    model: false,
    loading: false,
    action: {
      color: "warning",
      icon: "fas fa-times",
      text: 'Reject',
      disable: false,
    },
    onAction: (): void => {
      this.immediateRejectSubmit();
    },
  };

  public dialogRegenerateConfirmation: IDialogOption = {
    width: 400,
    title: this.$parent.$t("vendorRequestApproval.titleConfirmation") as string,
    model: false,
    loading: false,
    action: {
      color: "success",
      icon: "fas fa-check",
      text: this.$parent.$t("vendorRequestApproval.agree") as string,
    },
    onAction: (): void => {
      this.regenerateRequest();
    },
  };

  public vendorRequestHeaders: VHeaders[] = [
    { align: "left", isNotDataProp: true, sortable: false, text: "" },
    {
      align: "left",
      text: this.$parent.$t(
        "vendorRequestApproval.vendorHeaders.vendor"
      ) as string,
      value: "vendorNumber",
    },
    {
      align: "left",
      text: this.$parent.$t(
        "vendorRequestApproval.vendorHeaders.vendorName"
      ) as string,
      value: "searchName",
    },
    {
      align: "left",
      sortable: false,
      text: this.$parent.$t(
        "vendorRequestApproval.vendorHeaders.amountRequested"
      ) as string,
      value: "totalAmount",
    },
    {
      align: "left",
      sortable: false,
      text: this.$parent.$t(
        "vendorRequestApproval.vendorHeaders.hashInvoices"
      ) as string,
      value: "invoiceCount",
    },
    {
      align: "center",
      text: "Approval Details Required",
      sortable: false,
      fieldType: "button",
      class: "btn btn--icon",
      icon: { class: "fas fa-eye", color: "primary" },
      filters: [
        (val, item) => {
          return `${item.approvalCount}`;
        },
      ],
      onClick: (item) => {
        this.viewApproversModal(item);
      },
    },
    // { align: 'left', sortable: false, text: this.$parent.$t('vendorRequestApproval.vendorHeaders.status') as string, value: 'approvalStatus' },
    {
      align: "center",
      text: this.$parent.$t(
        "vendorRequestApproval.vendorHeaders.status"
      ) as string,
      fieldType: "template",
      sortable: false,
      template: (item) => {
        if (
          item.approvalStatus != undefined &&
          item.approvalStatus == "Approved" &&
          item.isAutoApproved
        ) {
          return `<span>AutoApproved</span>`;
        } else {
          return `<span>${item.approvalStatus}</span>`;
        }
      },
    },
    {
      align: "left",
      sortable: false,
      text: "Schedule On",
      value: "scheduleOn",
      fieldType: "date"
    },
    {
      align: "left",
      sortable: false,
      text: "Scheduled By",
      value: "paymentScheduledBy"
    },
    {
      align: "left",
      sortable: false,
      text: "Rejection Comment",
      value: "rejectionComment",
    },
    {
      text: "Created At",
      value: "createdAt",
      align: "left",
      fieldType: "date",
    },

    { align: "center", isNotDataProp: true, text: "Action", sortable: false },
  ];

  public vendorInvoiceHeaders: VHeaders[] = [
    {
      align: "left",
      sortable: false,
      text: this.$parent.$t(
        "vendorRequestApproval.vendorInvoiceHeaders.account"
      ) as string,
      value: "accountNumber",
    },
    {
      align: "left",
      sortable: false,
      text: this.$parent.$t(
        "vendorRequestApproval.vendorInvoiceHeaders.control"
      ) as string,
      value: "controlNumber",
    },
    {
      align: "left",
      sortable: false,
      text: this.$parent.$t(
        "vendorRequestApproval.vendorInvoiceHeaders.document"
      ) as string,
      value: "documentNumber",
    },
    {
      align: "left",
      sortable: false,
      text: this.$parent.$t(
        "vendorRequestApproval.vendorInvoiceHeaders.description"
      ) as string,
      value: "description",
    },
    {
      align: "left",
      sortable: false,
      text: this.$parent.$t(
        "vendorRequestApproval.vendorInvoiceHeaders.amount"
      ) as string,
      value: "transactionAmount",
    },
    { align: "center", isNotDataProp: true, text: "Action", sortable: false },
  ];

  public attachmentHeader: VHeaders[] = [
    {
      align: "left",
      sortable: false,
      text: this.$parent.$t(
        "vendorRequestApproval.attachmentHeader.attachmentType"
      ) as string,
      value: "typeName",
    },
    { align: "center", isNotDataProp: true, text: "Action", sortable: false },
  ];

  public questionGridHeader: VHeaders[] = [
    {
      align: "left",
      sortable: false,
      text: "From",
      value: "fromNumber",
      // template: (item) => {

      //   return `<span>${item.fromUser} (${item.fromNumber})</span>`;
      // }
    },
    {
      align: "left",
      sortable: false,
      text: "To",
      value: "toNumber",
      // fieldType: "template",
      // template: (item) => {

      //   return `<span>${item.toUser} (${item.toNumber})</span>`;
      // }
    },
    // {
    //   align: "left",
    //   sortable: false,
    //   text: "Text",
    //   value: "body",
    // },
    // {
    //   align: "left",
    //   sortable: false,
    //   text: "Date",
    //   value: "createdAt",
    //   fieldType: 'date',
    // },
    {
      align: "center",
      text: "Open Chat",
      sortable: false,
      fieldType: "button",
      class: "btn btn--icon",
      icon: { class: "fas fa-eye", color: "primary" },
      onClick: (item) => {
        this.setConversationMessageRoute(item);
      },
    },
  ];

  public lineItemsHeaders: VHeaders[] = [
    {
      align: "center",
      sortable: true,
      text: "Store Name",
      value: "storeName",
    },
    {
      align: "center",
      sortable: true,
      text: "Account Number",
      value: "accountNumber",
    },
    {
      align: "center",
      sortable: true,
      text: "Department",
      value: "department",
    },
    {
      align: "center",
      sortable: true,
      text: "Control Number",
      value: "controlNumber",
    },
    {
      align: "center",
      sortable: true,
      text: "Reference Number",
      value: "referenceNumber",
    },
    {
      align: "center",
      sortable: true,
      text: "Amount",
      value: "amount",
    },
    {
      align: "center",
      sortable: true,
      text: "Description",
      value: "description",
    },
    {
      align: "center",
      sortable: true,
      text: "Comment",
      value: "comment",
    },
  ];

  public setAttachmentActions(): void {
    this.attachmentActions = [
      {
        type: "button",
        icon: "fas fa-eye",
        title: this.$parent.$t(
          "vendorRequestApproval.viewAttachment"
        ) as string,
        color: "primary",
        visible: (model: any) => true,
        loading: false,
        action: (model: any, action: VAction) => {
          if (model.recordIdentifier != "RePay")
            this.viewAttachment(model.id, action);
          else if (model.uri) window.open(model.uri, "_blank");
        },
      },
      {
        type: "button",
        icon: "fa-map-marker",
        title: "Tracking Info",
        color: "primary",
        visible: (model: any) => {
          if (model.typeName == "Check" && model.recordIdentifier != "RePay") {
            return true;
          } else {
            return false;
          }
        },
        loading: false,
        action: (model: any, action: VAction) => {
          this.viewTrackingDialog(model);
        },
      },
    ];
  }

  public viewTrackingDialog(model): void {
    var filtered = this.attachmentsList?.filter(x => x.id == model.id) || [];
    var response = filtered[0]?.checkbookTrackingDetails?.tracking || [];
    
    if (response.length > 0) {
      this.checkBookDetails = response;
      this.trackingDialog.model = true;
    } else {
      this.showAlert(false, "No tracking info available.");
    }
  }

  public updateView() {
    if (this.approvalStatus == 'approved') {
      this.disbaleSchedulePaymentRejectionTextArea = true;
      this.rejectionComment = "";
    }
    else if (this.approvalStatus == 'rejected')
      this.disbaleSchedulePaymentRejectionTextArea = false;
  }

  public created(): void {
    if (this.$route.query.showVendorRequest !== undefined) {
    this.showVendorRequest =
      this.$route.query.showVendorRequest === "true";
  }
    this.params.startDate = this.subtractDaysFromPresent(90);
    this.params.endDate = this.presentDate();
  }
  public beforeDestroy() {
    const buttons = [];
    this.$emit("updateToolBar", buttons);
  }
  public callMethod(methodName): void {
    if (methodName === "search") {
      this.getVendorRequestApproval();
    }
    // if (methodName === 'backToList') {
    //     this.$router.push({ name: 'vendors.list' });
    // }

    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== "") {
      this.$emit("resetMethodName", methodName);
    }
  }
  public updateToolBar(): void {
    // const buttons: any = [];
    // buttons.push({ id: '0', type: 'button', title: this.$parent.$t('vendorRequestApproval.backToVendorsList'), disabled: false, visible: true, class: 'btn', label: this.$parent.$t('vendorRequestApproval.labelBack'), click: 'backToList', icon: 'fas fa-arrow-left', requestProgress: true });
    // this.$emit('updateToolBar', buttons);
  }

  public async mounted() {
    // activating tab
    this.$root.$emit("sidebar.layout.vue", "vendorSubmission");

    // Toolbar
    this.updateToolBar();
    this.$watch("methodtoCall", (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
    if (this.$route.query && this.$route.query.vendorNumber) {
      this.pagination.search = String(this.$route.query.vendorNumber);
      // this.status = "All";
      this.status = "Pending";
      const showVendorRequest = this.$route.query.showVendorRequest;
        if (showVendorRequest === "true" || showVendorRequest === "false") {
          this.applyMinimumStartDate = false;
        } else {
          this.applyMinimumStartDate = true; // when undefined
        }
    }

    if (this.$route.query && this.$route.query.storeKey) {
      this.storeKey = Number(this.$route.query.storeKey);
    }

    if (this.$route.query && this.$route.query.conversationId) {
      this.conversationId = this.$route.query.conversationId.toString();
      this.isQueryConversationId = true;
    }

    this.setActions();
    this.getVendorRequestApproval();
    this.setAttachmentActions();
    this.getMyExpenseTasks();
    this.setExpenseTaskAction();
  }

  public vendorInvalidRampDialog: IDialogOption = {
    width: 600,
    title: "Update Vendor",
    model: false,
    loading: false,
    action: {
      color: "success",
      icon: "fa-external-link",
      text: "Update Vendor Email/Phone",
    },
    onAction: () => {
      this.viewVendorEdit();
    },
  };

  public viewVendorEdit(): void {
    window.open(`${window.location.origin}/app/vendors/${this.vendorId}/edit`);
    this.vendorInvalidRampDialog.model = false;
  }

  public setActions() {
    this.vendorsActions = [
      {
        type: "button",
        icon: "fas fa-check",
        title: this.$parent.$t("vendorRequestApproval.vendorAction.Approve"),
        color: "success",
        disable: (model) => {
          if (
            model.approvalStatus === "approved" ||
            model.approvalStatus === "Approved" ||
            model.approvalStatus === "rejected"
          ) {
            return true;
          } else {
            return false;
          }
        },
        visible: (model) => {
          if (
            model.isApproverRole &&
            model.canApprove &&
            !model.extraApproval
          ) {
            return true;
          } else {
            return false;
          }
        },
        action: (model: any) => {
          if (model.approvalStatus === 'Scheduled') {
            this.vendorId = model.vendorId;
            this.vendorRequestId = model.id;
            this.immediateApproveDialogConfirmation.model = true;
          } else {
            this.vendorId = model.vendorId;
            this.vendorRequestId = model.id;
            this.approveDialogConfirmation.model = true;
            this.vendorNumber = model.vendorNumber;
          }
        },
      },
      {
        type: "button",
        icon: "fas fa-check",
        title: this.$parent.$t("vendorRequestApproval.vendorAction.Approve"),
        color: "success",
        visible: (model) => {
          if (model.extraApproval) {
            return true;
          } else {
            return false;
          }
        },
        action: (model: any) => {
          this.showAlert(
            true,
            "Request is Already Approved from your side, but need one more approve to full approve, As Check Request Amount Limit is more than the Limit you can approve!"
          );
        },
      },
      {
        type: "button",
        icon: "fas fa-times",
        title: this.$parent.$t("vendorRequestApproval.vendorAction.Reject"),
        color: "error",
        disable: (model: any) => {
          if (
        model.approvalStatus === "approved" ||
        model.approvalStatus === "Approved" ||
        model.approvalStatus === "rejected"
      )  {
            return true;
          } else {
            return false;
          }
        },
        visible: (model) => {
          if (model.isApproverRole && model.canApprove) {
            return true;
          } else {
            return false;
          }
        },
        action: (model: any) => {
          if (model.approvalStatus === 'Scheduled') {
            this.vendorRequestId = model.id;
            this.rejectionComment = "";
            this.vendorNumber = model.vendorNumber;
            this.immediateRejectDialogConfirmation.model = true;
          } else {
            this.vendorRequestId = model.id;
            this.rejectionComment = "";
            this.dialogConfirmation.model = true;
            this.vendorNumber = model.vendorNumber;
          }
        },
      },
      {
        type: "button",
        icon: "fas fa-redo-alt",
        title: this.$parent.$t(
          "vendorRequestApproval.vendorAction.resendpayment"
        ),
        disable: (model: any) => {
          if (
            model.approvalStatus === "approved" &&
            model.paymentType === "Virtual Card"
          ) {
            return false;
          } else {
            return true;
          }
        },
        visible: (model) => {
          if (model.isApproverRole) {
            return true;
          } else {
            return false;
          }
        },
        action: (model: any) => {
          this.requestId = model.id;
          this.dialogRegenerateConfirmation.model = true;
        },
      },
      {
        type: "button",
        icon: "fas fa-paperclip",
        title: this.$parent.$t(
          "vendorRequestApproval.vendorAction.attachments"
        ),
        color: "success",
        disable: (model) => {
          return false;
        },
        action: (model: any) => {
          this.showVendorRequestAttachments(model);
        },
      },
      {
        type: "button",
        icon: "fa-th-list",
        title: "View Line Item",
        color: "primary",
        visible: (model) => {
          if (model.approvalStatus === "approved") {
            return true;
          } else {
            return false;
          }
        },
        action: (model: any) => {
          this.showLineItems(model);
        },
      },
      {
        type: "button",
        icon: "fa-comments-o",
        title: "Chat",
        color: "primary",
        visible: (model: any) => !(this.userId == model.createdBy),
        action: (model: any) => {
          // this.openConversation(model);
          this.setVendorPhoneNumber(model);
          this.submitUserId = model.createdBy;
          this.externalId = model.externalId;
          this.dialogQuestion.model = true;
          this.isRedirectToConversation = true;
        },
      },
    ];
    this.vendorsLineItemActions = [
      {
        type: "link",
        icon: "fas fa-eye",
        title: this.$parent.$t(
          "vendorRequestApproval.vendorAction.viewDetails"
        ),
        color: "primary",
        disable: (model: any) => {
          if (model.expenseId > 0) {
            return false;
          }
          return true;
        },
        action: (model: any) => {
          return {
            name: "app.expenses.edit",
            params: {
              expenseId: encodeURIComponent(model.expenseId),
              mode: "view",
            },
          };
        },
      },
    ];
  }

  public async showLineItems(model: any) {
    try {
      this.dialogLineItems.model = true;
      this.lineItemsloading = true;

      const approvals = model.vendorRequestApprovalJson ?? [];

      var lstDocumentNumber = approvals.map((x) => x.documentNumber);
      var lstreferenceNumber = approvals.map((x) => x.referenceNumber);
      const response = await vendorService.getVendorLineItems(
        lstDocumentNumber,
        lstreferenceNumber
      );
      this.vendorLineItemsList = response.lineItems;
    } finally {
      this.lineItemsloading = false;
    }
  }

  public async viewAttachment(
    attachmentId: string,
    action: VAction
  ): Promise<void> {
    try {
      action.loading = true;
      await attachmentService.viewAttachmentAsync(attachmentId);
    } finally {
      action.loading = false;
    }
  }

  public async getVendorRequestApproval(): Promise<void> {
    try {
      this.loading = true;
      this.$emit("update:progress", this.loading);
      const response = await vendorService.getRequestApprovalAsync(
        this.params.startDate,
        this.params.endDate,
        this.status,
        this.storeKey,
        this.pagination,
        this.conversationId,
        this.applyMinimumStartDate
      );
      this.pagedVendors = response.results;
      this.pagination.totalItems = response.total;
    } finally {
      this.loading = false;
      this.conversationId = "";
      this.$emit("update:progress", this.loading);
    }
  }

  public updatePaging(paging: any) {
    this.pagination = paging;
    this.getVendorRequestApproval();
  }

  public async rejectionSubmit() {
    if (!this.rejectionComment) {
      this.showAlert(
        false,
        this.$parent.$t("vendorRequestApproval.alertEnterRejectionReason")
      );
      return;
    }
    try {
      this.dialogConfirmation.loading = true;
      await this.approveOrReject(
        "rejected",
        this.vendorRequestId,
        this.rejectionComment
      );
    } finally {
      // this.dialogConfirmation.loading = false;
      // this.dialogConfirmation.model = false;
      // this.dialogAttachments = false;
      // await this.showNextApprovalRequest();
    }
  }

  public async approvalSubmit() {
    try {
      this.approveDialogConfirmation.loading = true;
      await this.approveOrReject("approved", this.vendorRequestId);
    } finally {
      // this.approveDialogConfirmation.loading = false;
      // this.approveDialogConfirmation.model = false;
      // this.dialogAttachments = false;
      // this.showNextApprovalRequest();
    }
  }

  public async immediateApprovalSubmit() {
    try {
      this.immediateApproveDialogConfirmation.loading = true;
      await this.reSchedulePayment("immediate-approve");
    } finally {
      this.immediateApproveDialogConfirmation.loading = false;
      this.immediateApproveDialogConfirmation.model = false;
      //this.dialogAttachments = false;
      // this.showNextApprovalRequest();
    }
  }

  public async immediateRejectSubmit() {
    try {
      this.immediateRejectDialogConfirmation.loading = true;
      const vendorDetails = await vendorService.getVendorDetailsByVendorNumber(
        this.vendorNumber.toString()
      );
      if (!vendorDetails || (vendorDetails && !vendorDetails.vendorNumber)) {
        this.showAlert(false, 'Vendor Details Not Found. Please Update Vendor Details');
        return;
      }
      if (!vendorDetails.billAddress1 && !vendorDetails.paymentAddress1) {
        this.showAlert(false, 'Vendor Address not found. Please Update Vendor Details');
        return;
      }
      if (!vendorDetails.billCity && !vendorDetails.paymentCity) {
        this.showAlert(false, 'Vendor City not found. Please Update Vendor Details');
        return;
      } if (!vendorDetails.billStateCode && !vendorDetails.paymentStateCode) {
        this.showAlert(false, 'Vendor State Code not found. Please Update Vendor Details');
        return;
      }
      if (!vendorDetails.billZipCode && !vendorDetails.paymentZipCode || (vendorDetails.billZipCode == '0' && vendorDetails.paymentZipCode == '0')) {
        this.showAlert(false, 'Vendor Zip Code not found. Please Update Vendor Details');
        return;
      }
      await this.reSchedulePayment("immediate-reject");
    } finally {
      this.immediateRejectDialogConfirmation.loading = false;
      this.immediateRejectDialogConfirmation.model = false;
      //this.dialogAttachments = false;
      // this.showNextApprovalRequest();
    }
  }


  public async showVendorRequestAttachments(model: any) {
    if (model.id) {
      this.questionGridLoading = true;
      // set parameter for ask question API
      this.submitUserId = model.createdBy;
      this.transactionHeaderId = model.transactionHeaderId;
      this.externalId = model.externalId;
      this.vendorNumber = model.vendorNumber;
      if (model.createdBy != this.userId) {
        this.isBtnShowQuestion = true;
        this.isShowConversationGrid = true;
      } else {
        this.isBtnShowQuestion = false;
        this.isShowConversationGrid = true;
      }


      if (model.isApproverRole && model.canApprove) {
        this.hasApprovalPermissions = true;
      } else {
        this.hasApprovalPermissions = false;
      }

      if (
        model.approvalStatus === "approved" ||
        model.approvalStatus === "Approved" ||
        model.approvalStatus === "rejected"
      ) {
        this.isRequestCompleted = true;
      } else {
        this.isRequestCompleted = false;
        if (model.isApproverRole && model.canApprove && !model.extraApproval) {
          this.isExtraApprovalRequired = false;
        } else {
          this.isExtraApprovalRequired = true;
        }
      }

      if (model.scheduleOn) {
        this.isRequestPaymentScheduled = true;
        this.paymentSendDate = this.$moment(model.scheduleOn).format("YYYY-MM-DD");
        this.schedulePaymentHintText = "Payment has already been scheduled";
        if(model.approvalCount > model.approvedBy.length && model.extraApproval){
          this.isNeedsExtraApproval = true;
        }else{
          this.isNeedsExtraApproval = false;
        }
      } else {
        this.isRequestPaymentScheduled = false;
        this.schedulePaymentHintText = "";
      }
      this.isRequiresMultipleApprovals = model.approvalCount > 1;

      this.isStatusPending = model.approvalStatus === 'pending';

      //add approval and reject code here
      if (
        model.approvalStatus === "approved" ||
        model.approvalStatus === "Approved" ||
        model.approvalStatus === "rejected"
      ) {
        this.isBtnDisableRequestApproval = true;
      } else {
        this.isBtnDisableRequestApproval = false;
      }


      if (model.isApproverRole && model.canApprove && !model.extraApproval) {
        this.isBtnShowApproval = true;
      } else {
        this.isBtnShowApproval = false;
      }

      this.vendorId = model.vendorId;
      this.vendorRequestId = model.id;
      this.rejectionComment = "";

      if (
        model.approvalStatus === "approved" ||
        model.approvalStatus === "rejected"
      ) {
        this.isBtnDisableRequestReject = true;
      } else {
        this.isBtnDisableRequestReject = false;
      }

      if (model.isApproverRole && model.canApprove) {
        this.isBtnShowReject = true;
      } else {
        this.isBtnShowReject = false;
      }


      if (model.paymentScheduledBy != undefined && model.scheduleOn != undefined && model.paymentScheduledBy && model.scheduleOn) {
        this.disableSchedulePaymentSection = true;
        this.disableReSchedulePaymentSection = false;
        this.schedulePaymentHintText = "Payment has already been scheduled";
      } else if (model.approvalStatus != "approved" && model.approvalStatus != "rejected") {
        this.disableSchedulePaymentSection = false;
        this.disableReSchedulePaymentSection = true;
        this.schedulePaymentHintText = "";
      } else {
        this.disableSchedulePaymentSection = true;
        this.disableReSchedulePaymentSection = true;
      }

      try {
        this.attachmentloading = true;
        const response = await vendorService.getVendorRequestAttachmentsAsync(
          model.id,
          this.attachmentPagination
        );
        this.attachmentHeaderText = `(${model.searchName} $${model.totalAmount})`;
        this.dialogAttachments = true;
        this.attachmentsList = response.results;
      } finally {
        this.getVendorMessages(this.externalId);
        this.attachmentloading = false;
      }
    }
  }

  public async getVendorMessages(externalId: string) {
    if (this.externalId) {
      const questionQueryResponse =
        await vendorService.getVendorQueryExistingMessages(externalId);
      this.questionGridList = questionQueryResponse;
      this.questionPagination.totalItems = this.questionGridList.length || 0;
      this.questionGridLoading = false;
    }
  }

  public async approveOrReject(
    status: string,
    id: number,
    rejectionComment: string = ""
  ) {
    if (status && id) {
      try {
        this.processedRequest.push(id);
        const vendorDetails = await vendorService.getVendorDetailsByVendorNumber(
          this.vendorNumber.toString()
        );
        if (!vendorDetails || (vendorDetails && !vendorDetails.vendorNumber)) {
          this.showAlert(false, 'Vendor Details Not Found. Please Update Vendor Details');
          return;
        }
        if (!vendorDetails.billAddress1 && !vendorDetails.paymentAddress1) {
          this.showAlert(false, 'Vendor Address not found. Please Update Vendor Details');
          return;
        }
        if (!vendorDetails.billCity && !vendorDetails.paymentCity) {
          this.showAlert(false, 'Vendor City not found. Please Update Vendor Details');
          return;
        } if (!vendorDetails.billStateCode && !vendorDetails.paymentStateCode) {
          this.showAlert(false, 'Vendor State Code not found. Please Update Vendor Details');
          return;
        }
        if (!vendorDetails.billZipCode && !vendorDetails.paymentZipCode || (vendorDetails.billZipCode == '0' && vendorDetails.paymentZipCode == '0')) {
          this.showAlert(false, 'Vendor Zip Code not found. Please Update Vendor Details');
          return;
        }

        var vendor = this.pagedVendors.find(x => x.id == this.vendorRequestId);
        if (vendor.paymentScheduledBy != undefined && vendor.scheduleOn != undefined && vendor.paymentScheduledBy && vendor.scheduleOn && status != "rejected") {
          this.approvalStatus = status;
          await this.schedulePayment();
          return;
        }

        const response = await vendorService.updateSubmissionDecisionAsync(
          status,
          id,
          rejectionComment
        );
        if (response.status == false && response.isValidVendor == false) {
          this.vendorInvalidRampDialog.model = true;
          this.message =
            "Can't Create Card, Because Backend Card Provider Doesn't Allow Card Creation Without email/phone, Please Click On below button to Update Vendor email/phone";
          if (status == "approved") {
            this.approveDialogConfirmation.loading = false;
            this.approveDialogConfirmation.model = false;
            this.dialogAttachments = false;
          } else if (status == "rejected") {
            this.dialogConfirmation.loading = false;
            this.dialogConfirmation.model = false;
            this.dialogAttachments = false;
          }
        } else {
          this.showAlert(true, response.responseMessage);
          await this.getVendorRequestApproval();
          if (status == "approved") {
            this.approveDialogConfirmation.loading = false;
            this.approveDialogConfirmation.model = false;
            this.dialogAttachments = false;
          } else if (status == "rejected") {
            this.dialogConfirmation.loading = false;
            this.dialogConfirmation.model = false;
            this.dialogAttachments = false;
          }
          await this.showNextApprovalRequest();
        }
      } finally {

        if (status == "approved") {
          this.approveDialogConfirmation.loading = false;
          this.approveDialogConfirmation.model = false;
          this.dialogAttachments = false;
        } else if (status == "rejected") {
          this.dialogConfirmation.loading = false;
          this.dialogConfirmation.model = false;
          this.dialogAttachments = false;
        }
      }
    }
  }

  public async showNextApprovalRequest(): Promise<void> {
    if (this.pagedVendors.length > 0) {
      if (this.processedRequest.length == 0) {
        var requestDetail = this.pagedVendors[0];
        this.showVendorRequestAttachments(requestDetail);
      } else {
        var filterDetails = this.pagedVendors.filter(
          (item) => !this.processedRequest.includes(item.id)
        );
        if (filterDetails.length > 0) {
          this.showVendorRequestAttachments(filterDetails[0]);
        }
      }
    }
  }

  public getVendorInvoices(vendor) {
    return vendor.vendorRequestApprovalJson;
  }

  public async regenerateRequest(): Promise<void> {
    if (!this.requestId) {
      this.showAlert(
        false,
        this.$parent.$t("vendorRequestApproval.alertVendorIsEmpty")
      );
      return;
    }
    try {
      this.dialogRegenerateConfirmation.loading = true;
      await vendorService.regenerateRequestAsync(this.requestId);
      this.showAlert(
        true,
        this.$parent.$t("vendorRequestApproval.alertRegeneratedRequest")
      );
      this.getVendorRequestApproval();
    } finally {
      this.dialogRegenerateConfirmation.loading = false;
      this.dialogRegenerateConfirmation.model = false;
    }
  }
  public UpdateDateParms(dates: any) {
    if (dates.length > 1) {
      this.params.startDate = dates[0];
      this.params.endDate = dates[1];
    }
  }

  public ondialogQuestionActionClick(): void {
    this.sumbitSendApprovalQuery();
  }
  public setError(fieldName, errorMsg) {
    this.$validator.errors.add({ field: fieldName, msg: errorMsg });
  }

  public async sumbitSendApprovalQuery() {
    if (this.userQuestion.length < 1) {
      this.setError("User Question", "Question field is required.");
      return;
    }

    try {
      this.dialogQuestion.loading = true;
      var queryResponse = await vendorService.sendApprovalConversationEmail(
        this.externalId,
        this.submitUserId,
        this.userQuestion
      );
      if (queryResponse) {
        this.showAlert(true, "Conversation link has been send successfully.");
      }
      this.dialogQuestion.model = false;
      this.dialogAttachments = false;
    } finally {
      this.userQuestion = "";
      this.dialogQuestion.loading = false;
      if (this.isRedirectToConversation) {
        this.rediectToConversation(queryResponse.toNumber);
      }
    }
  }

  public viewApproversModal(model) {
    this.ApproversList = [];
    this.dialogviewApprovers.model = true;
    this.ApproversList = model.approvedBy;
  }

  public updateQuestionPaging(paging: any) {
    this.questionPagination = paging;
  }

  // public async openConversation(model) {
  //   try {
  //     this.dialogQuestion.loading = true;
  //     var queryResponse = await vendorService.sendApprovalConversationEmail(model.externalId, model.createdBy);

  //     if (queryResponse.status == true) {
  //       this.$router.push({
  //         name: 'vendorconversations',
  //         params: {
  //           tenantId: this.userSession.tenantId.toString(),
  //           enterpriseId: this.userSession.enterpriseId.toString(),
  //           storeId: model.storeId.toString(),
  //           conversationId: model.externalId,
  //           toNumber : queryResponse.toNumber
  //         },
  //       });
  //     }
  //   } finally {
  //     this.dialogQuestion.loading = false;
  //   }
  // }

  public async setConversationMessageRoute(model) {
    if (model.toNumber) {
      this.$router.push({
        name: "vendorconversations",
        params: {
          tenantId: this.userSession.tenantId.toString(),
          enterpriseId: this.userSession.enterpriseId.toString(),
          storeId: this.userSession.storeId.toString(),
          conversationId: this.externalId,
          toNumber:
            this.userSession.sessionUserId == model.createdBy
              ? model.fromNumber
              : model.toNumber,
        },
      });
    }
  }

  public rediectToConversation(toNumber) {
    this.$router.push({
      name: "vendorconversations",
      params: {
        tenantId: this.userSession.tenantId.toString(),
        enterpriseId: this.userSession.enterpriseId.toString(),
        storeId: this.userSession.storeId.toString(),
        conversationId: this.externalId,
        toNumber: toNumber,
      },
    });
  }

  public resetVendorRequestApproval() {
    this.$router.push({
      name: "vendors.approval",
    });
  }

  public resetCustomerSearch() {
    this.paginationExpenseTasks.search = "";
    this.getMyExpenseTasks();
  }

  public async navigateToConversation() {
    if (this.externalId) {
      if (this.vendorConversationToNumber != "") {
        this.$router.push({
          name: "vendorconversations",
          params: {
            tenantId: this.userSession.tenantId.toString(),
            enterpriseId: this.userSession.enterpriseId.toString(),
            storeId: this.userSession.storeId.toString(),
            conversationId: this.externalId,
            toNumber: this.vendorConversationToNumber,
          },
        });
      }
    }
  }

  public async setVendorPhoneNumber(model) {
    this.vendorConversationToNumber = "";
    var questionQueryResponse =
      await vendorService.getVendorQueryExistingMessages(model.externalId);
    if (questionQueryResponse) {
      this.vendorConversationToNumber = questionQueryResponse[0].toNumber;
    }
  }

  public paginationExpenseTasks = new PaginationModel("id", true);

  public async getMyExpenseTasks(): Promise<void> {
    try {
      this.customerloading = true;
      this.$emit("update:progress", this.loading);
      const tasks = await expenseService.getCustomerTasksAsync(
        this.paginationExpenseTasks,
        this.showMyTasks,
        false,
        true
      );
      this.pagedExpenseTaskRecords = tasks.results;
      if (tasks.results.length > 0) {
        this.paginationExpenseTasks.totalItems = tasks.total;
      } else {
        this.paginationExpenseTasks.totalItems = 0;
      }
    } finally {
      this.customerloading = false;
      this.$emit("update:progress", this.loading);
    }
  }

  public updatePagingExpenseTask(taskPaging: any) {
    this.paginationExpenseTasks = taskPaging;
    //this.getRoutingData();
    this.getMyExpenseTasks();
  }

  public dialogApprove: IDialogOption = {
    width: 610,
    title: this.$parent.$t("myExpense.dialogApprove.title") as string,
    model: false,
    loading: false,
    action: {
      color: "success",
      icon: "fas fa-fa-thumbs-up",
      text: this.$parent.$t("myExpense.dialogApprove.btnText") as string,
    },
    onAction: this.onApprove,
  };

  public setExpenseTaskAction() {
    this.expenseTaskActions = [
      {
        type: "link",
        icon: "fas fa-eye",
        color: "primary",
        title: this.$parent.$t(
          "myExpense.expenseTaskActions.viewDetails"
        ) as string,
        visible: (model: any) => true,
        action: (model: any) => {
          return {
            name: "app.expenses.edit",
            params: {
              expenseId: encodeURIComponent(model.expenseId),
              mode: "view",
              expenseType: model.expenseType,
            },
          };
        },
      },
      {
        type: "button",
        icon: "fas fa-thumbs-up",
        title: this.$parent.$t(
          "myExpense.expenseTaskActions.approve"
        ) as string,
        color: "green",
        visible: (model) => {
          if (
            model.approvalStatus === "Pending" &&
            (model.isExpenseApprovalOverrider || model.isManager)
          ) {
            return true;
          }
          return false;
        },
        action: (model: any) => {
          this.decisionType = model.isManager ? "manager" : "expenseOverrider";
          this.selectedExpenseId = model.expenseId;
          this.selectedStoreId = model.storeId;
          this.dialogApprove.model = true;
        },
      },
      {
        type: "button",
        icon: "fas fa-thumbs-down",
        title: this.$parent.$t("myExpense.expenseTaskActions.reject") as string,
        color: "red",
        visible: (model) => {
          if (
            model.approvalStatus === "Pending" &&
            (model.isExpenseApprovalOverrider || model.isManager)
          ) {
            return true;
          }
          return false;
        },
        action: (model: any) => {
          this.decisionType = model.isManager ? "manager" : "expenseOverrider";
          this.selectedExpenseId = model.expenseId;
          this.selectedStoreId = model.storeId;
          this.dialogRejection.model = true;
        },
      },
    ];
  }

  public onApprove(): void {
    this.ApproveOrRejectExpense(this.decisionType, true);
  }

  public onRejection(): void {
    this.ApproveOrRejectExpense(this.decisionType, false);
  }

  public async ApproveOrRejectExpense(decisionType, isApproved) {
    if (!isApproved) {
      if (this.rejectionComment.length < 1) {
        this.setError(
          "Rejection Comment",
          this.$t("expenseAdd.pleaseAddRejectionComment")
        );
        return;
      }
    }
    try {
      this.dialogApprove.loading = true;
      this.dialogRejection.loading = true;
      const response = await expenseService.approvelOrRejectExpenseAsync(
        this.selectedExpenseId,
        isApproved,
        this.rejectionComment,
        decisionType,
        this.selectedStoreId,
        this.overriderApprovalMsg
      );
      this.showAlert(response.isApproved, response.responseMessage);
      this.dialogRejection.model = false;
      this.dialogApprove.model = false;
      this.rejectionComment = "";
      this.getMyExpenseTasks();
    } finally {
      this.dialogApprove.loading = false;
      this.dialogRejection.loading = false;
    }
  }

  public dialogRejection: IDialogOption = {
    width: 610,
    title: this.$parent.$t("myExpense.dialogRejection.title") as string,
    model: false,
    loading: false,
    action: {
      color: "success",
      icon: "fas fa-thumbs-down",
      text: this.$parent.$t("myExpense.dialogRejection.btnText") as string,
    },
    onAction: this.onRejection,
  };

  public toggleVendorRequest() {
    this.$router.replace({
    query: {
      ...this.$route.query,
      showVendorRequest: this.showVendorRequest.toString(),
    },
  });
  }

  public async schedulePayment() {
    try {
      this.paymentBtnLoading = true;
      this.schedulePaymentBtnLoading = true;

      if (this.approvalStatus == "rejected" && !this.rejectionComment) {
        this.showAlert(false, this.$parent.$t("vendorRequestApproval.alertEnterRejectionReason"));
        return;
      }

      // Changes - scheduled changes can only be approved.
      let status = 'approved';

      var approvalCount = this.pagedVendors.find(x => x.id == this.vendorRequestId)?.approvalCount;
      const response = await paymentService.schedulePaymentRequest(this.vendorRequestId.toString(), this.rejectionComment, status, this.paymentSendDate, approvalCount);
      if (response.status) {
        this.showAlert(true, response.message);
        this.dialogSchedulePaymentConfirmation = false;
        this.dialogAttachments = false;
        await this.getVendorRequestApproval();
      }

    }
    finally {
      this.paymentBtnLoading = false;
      this.schedulePaymentBtnLoading = false;
    }
  }

  public async reSchedulePayment(action: string = null) { // reschedule, immediate-approve, immediate-reject
    try {
      this.reSchedulePaymentLoading = true;
      this.reSchedulePaymentBtnLoading = true;

      if ((action == 'immediate-reject') && !this.rejectionComment) {
        this.showAlert(false, this.$parent.$t("vendorRequestApproval.alertEnterRejectionReason"));
        return;
      }
      let status = action == 'immediate-reject' ? 'rejected' : 'approved';
      var approvalCount = this.pagedVendors.find(x => x.id == this.vendorRequestId)?.approvalCount;
      const response = await paymentService.reSchedulePaymentRequest(this.vendorRequestId.toString(), this.rejectionComment, status, this.paymentRescheduleDate, approvalCount, action);
      if (response.status) {
        this.showAlert(true, response.message);
        this.dialogReScheduleConfirmation = false;
        this.dialogImmediateApproveConfirmation = false;
        this.dialogImmediateRejectConfirmation = false;
        this.dialogAttachments = false;
        await this.getVendorRequestApproval();
      }

    }
    finally {
      this.reSchedulePaymentLoading = false;
      this.reSchedulePaymentBtnLoading = false;
    }
  }

  public setMinimumStartDate(dates: any): void {
    if (!dates || dates.length <= 1) return;

    const startDate = this.subtractDaysFromPresent(90);
    const endDate = this.presentDate();

    this.applyMinimumStartDate = (startDate === dates[0] && endDate === dates[1]);
  }
}
